import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '../config';
import i18n, { getLocales, getLanguage, setLanguage } from '../utils/i18n';
import Collapse from 'react-bootstrap/Collapse';

const Footer = () => {
    const [displayCookieSettings, setDisplayCookieSettings] = useState(false);

    return (
        <footer className="page-footer font-small pt-4">
            <div className="container-fluid text-center text-md-left">
                <div className="row">
                    <div className="col-md-6 mt-md-0 mt-3">
                        <h5 className="text-uppercase">{i18n.FOOTER_SETTINGS_HEAD}</h5>
                        <p>{i18n.FOOTER_SETTINGS_DESCRIPTION}</p>

                        <div className="row">
                            <div className="col">
                                <label className="settings-option-label">
                                    <span className="settings-option-pre">
                                        <i className="fa fa-cookie-bite"> </i>
                                    </span>
                                    <button className="settings-option" onClick={e => setDisplayCookieSettings(!displayCookieSettings)}>
                                        {i18n.FOOTER_SETTINGS_OPTION_COOKIES}
                                    </button>
                                </label>
                                <Collapse in={displayCookieSettings}>
                                    <div className="mb-4">
                                        {i18n.FOOTER_SETTINGS_OPTION_COOKIES_ALERT}
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label className="settings-option-label">
                                    <span className="settings-option-pre">
                                        <i className="fa fa-globe-americas"> </i>
                                    </span>
                                    <select className="settings-option" value={getLanguage()} onChange={e => setLanguage(e.target.value)}>
                                        { Object.entries(getLocales()).map(locale => <option key={locale[0]} value={locale[0]}>{locale[1]}</option>) }
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr className="clearfix w-100 d-md-none pb-3" />
                    <div className="col-md-3 mb-md-0 mb-3">
                        <h5 className="text-uppercase">{i18n.FOOTER_MORE_LINKS_HEAD}</h5>
                        <ul className="list-unstyled">
                            <li>
                                <Link to={CONFIG.ROUTES.FAQ}>{i18n.NAV_FAQ}</Link>
                            </li>
                            <li>
                                <Link to={{pathname: CONFIG.ROUTES.CONTACT, query: {reason: 'suggestion'}}}>{i18n.FOOTER_SUGGESTIONS}</Link>
                            </li>
                            <li>
                                <Link to={CONFIG.ROUTES.IMPRINT}>{i18n.NAV_IMPRINT}</Link>
                            </li>
                            <li>
                                <Link to={CONFIG.ROUTES.SITEMAP}>{i18n.NAV_SITEMAP}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-3 mb-md-0 mb-3">
                        <a href="http://internetdefenseleague.org" target="_blank" rel="noopener noreferrer">
                            <img src="http://internetdefenseleague.org/images/badges/final/shield_badge.png" style={{maxWidth: '50%'}} alt="Internet Defense League" title={i18n.FOOTER_IDL_TITLE} />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <ul className="list-unstyled list-inline text-center mt-3 py-4 social-media-wrap">
                    <li className="list-inline-item">
                        <a className="btn-floating btn-youtube mx-1" href="https://www.youtube.com/wesoneakaINM" target="_blank" rel="noopener noreferrer" title="YouTube">
                            <i className="fab fa-youtube"> </i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a className="btn-floating btn-facebook mx-1" href="https://www.facebook.com/inmentertainment" target="_blank" rel="noopener noreferrer" title="Facebook">
                            <i className="fab fa-facebook-f"> </i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a className="btn-floating btn-skype mx-1" href="skype:INM-entertainment" target="_blank" rel="noopener noreferrer" title="Skype">
                            <i className="fab fa-skype"> </i>
                        </a>
                    </li>
                </ul>
            </div>
            <div className="footer-copyright text-center py-3">
                Copyright © 2011 - {new Date().getFullYear()} <a href={CONFIG.ROUTES.HOME}>INM</a> | 4/23
            </div>
        </footer>
    );
};

export default Footer;
